module.exports = __webpack_public_path__ + "static/media/Haunter_gaussian2.94be9b45.png";